module.exports = __webpack_public_path__ + "img/2.df5f2c1b.png";